<template>
  <div>
    <serviceList
      :pageTitle="$t('internationAirPage.featureTitle')"
      :titleDesc="$t('internationAirPage.featureText')"
      :bannerUrl="bannerUrl"
      :characterList="characterList"
      :imgTextList="imgTextList"
      isRightPostion
    />
  </div>
</template>

<script setup>
import serviceList from '../../components/template/serviceList.vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const bannerUrl = require('@assets/images/banner/banner-international-air.png');
const characterList = [
  {
    img: require('@assets/icons/ico-feature_1.svg'),
    title: t('internationAirPage.feature1.title'),
    text: t('internationAirPage.feature1.text'),
  },
  {
    img: require('@assets/icons/ico-feature_2.svg'),
    title: t('internationAirPage.feature2.title'),
    text: t('internationAirPage.feature2.text'),
  },
  {
    img: require('@assets/icons/ico-feature_3.svg'),
    title: t('internationAirPage.feature3.title'),
    text: t('internationAirPage.feature3.text'),
  },
]
const imgTextList = [
  {
    img: require('@assets/images/interational_air_img_1.png'),
    title: t('internationAirPage.description1.title'),
    text: t('internationAirPage.description1.text'),
  },
  {
    img: require('@assets/images/interational_air_img_2.png'),
    title: t('internationAirPage.description2.title'),
    text: t('internationAirPage.description2.text'),
  },
]
</script>